import { globals } from "@/core/globals";

const DATA_AREA_ID_TO_TENANT: Record<string, string> = {
  UK0: "thorlabsuk",
  THO: "thorlabs",
  MUC: "thorlabsgmbh",
  FRA: "thorlabssas",
  SWE: "thorlabsswe",
};

export const usePayerAuthentication = () => {
  const is3DSPayerAuthenticationEnabled = (dataAreaId: string): boolean => {
    const flagValue = globals.enable3DSPayerAuthentication;
    if (!flagValue) {
      return false;
    }
    const effectiveDataAreaId = dataAreaId;
    const tenant = DATA_AREA_ID_TO_TENANT[effectiveDataAreaId];
    if (!tenant) {
      return false;
    }
    const allowedTenants = flagValue.split(",").map((id) => id.trim().toLowerCase());
    return allowedTenants.includes(tenant);
  };

  return {
    is3DSPayerAuthenticationEnabled,
  };
};
